'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ItemLimitReachedAlert = require('./components/ItemLimitReachedAlert.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemLimitReachedAlert).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/item-limit-reached-alert/index.js
// module id = 1303
// module chunks = 0